/* Ziorigin managed JS fixes. */
(function () {
  /* 0) Swallow errors thrown inside theme MutationObserver callbacks. The Swym
     wishlist observer in custom.js calls node.id.indexOf on nodes whose id isn't
     a string, logging a harmless TypeError. Pure try/catch, no other behaviour. */
  try {
    var _MO = window.MutationObserver || window.WebKitMutationObserver;
    if (_MO) {
      function _P(cb) { return new _MO(function (recs, obs) { try { return cb(recs, obs); } catch (e) {} }); }
      _P.prototype = _MO.prototype;
      window.MutationObserver = _P;
      window.WebKitMutationObserver = _P;
    }
  } catch (e) {}

  /* 1) Mobile header: add an Account/login icon next to the wishlist + bag icons. */
  function addAccountIcon() {
    var right = document.querySelector('.header__mobile__right');
    if (!right || right.querySelector('.zi-account-btn')) return;
    var wrap = document.createElement('div');
    wrap.className = 'header__mobile__button zi-account-btn';
    var a = document.createElement('a');
    a.href = '/account';
    a.className = 'navlink';
    a.setAttribute('aria-label', 'Account');
    a.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="3.5"></circle><path d="M5 20c0-3.6 3.1-5.6 7-5.6s7 2 7 5.6"></path></svg>';
    wrap.appendChild(a);
    right.insertBefore(wrap, right.firstElementChild);
  }

  /* 2) Product info drawer: remove the duplicate heading in the body that just
     repeats the drawer title (e.g. title "The piece" + a stray <p>The piece</p>). */
  function dedupeSheetHeadings() {
    document.querySelectorAll('.pdt-sheet').forEach(function (sheet) {
      var titleEl = sheet.querySelector('.pdt-sheet__title');
      var body = sheet.querySelector('.pdt-sheet__body');
      if (!titleEl || !body) return;
      var title = titleEl.textContent.trim().toLowerCase();
      if (!title) return;
      Array.prototype.forEach.call(body.children, function (c) {
        if (c.tagName === 'P' && !c.className && c.textContent.trim().toLowerCase() === title) {
          c.style.display = 'none';
        }
      });
    });
  }

  /* 3) Contact drawer: the "Prefer WhatsApp?" link used tel: (dials the number)
     instead of opening WhatsApp. Point it at wa.me. */
  function fixWhatsAppLink() {
    var a = document.querySelector('.contact-drawer__call a[href^="tel:"]');
    if (a) { a.setAttribute('href', 'https://wa.me/919006606960'); a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener'); }
  }

  function run() { try { addAccountIcon(); } catch (e) {} try { dedupeSheetHeadings(); } catch (e) {} try { fixWhatsAppLink(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 600); });
  document.addEventListener('click', function () { setTimeout(dedupeSheetHeadings, 250); }, true);
})();
